/**
 * @module @mkt-common/shopee-common
 */
/**
 * @hidden
 */
function getAndroidVersion(ua) {
    const match = ua.toLocaleLowerCase().match(/android\s([0-9\.]*)/);
    return match ? match[1] : '';
}
const getIosVersion = (ua) => {
    const uaReg = /OS ((\d+_?){2,3})\s/i;
    const result = ua.match(uaReg);
    if (result && result.length && result[0]) {
        // result[0] 类似 "OS 10_3_1 "
        const versionArr = result[0].trim().split(/\s/);
        if (versionArr && versionArr.length && versionArr[1]) {
            // versionArr[1] 类似 10_3_1
            // versionText 格式 '10.3.1'
            const versionText = versionArr[1].split('_').join('.');
            return versionText;
        }
    }
    return '';
};
function getBrowserObject(ua, originalUrl) {
    const browser = {};
    const isShopeeApp = ua.match('Shopee');
    const isIos = ua.indexOf('iPhone') >= 0 || ua.indexOf('iPad') >= 0 || ua.indexOf('iPod') >= 0;
    const isAndroid = ua.indexOf('Android') > 0;
    const uaLocale = ua.match(/locale=(\S+) /);
    const isShopeeLite = /lite\.(test\.|uat\.)?shopee/.test(originalUrl);
    browser.shopeeApp = !!isShopeeApp;
    browser.ios = isIos;
    browser.android = isAndroid;
    browser.mweb = (isIos || isAndroid) && !isShopeeApp;
    browser.pc = !isIos && !isAndroid && !isShopeeApp;
    browser.pcmall = browser.pc && originalUrl.search('scenario=1') >= 0; // if the url query contains `scenario=1` means it's embedded in iframe
    browser.isShopeeLite = isShopeeLite;
    browser.osVersion = isAndroid ? getAndroidVersion(ua) : '';
    browser.mobileOsVersion = isAndroid ? getAndroidVersion(ua) : getIosVersion(ua);
    if (uaLocale) {
        browser.locale = uaLocale[1];
    }
    return browser;
}
function detectBrowser(userAgent, href) {
    // RN 环境没有window.location
    if (typeof window !== 'undefined' && window.navigator && window.location) {
        const ua = window.navigator.userAgent;
        const originalUrl = window.location.href;
        if (!ua || !originalUrl) {
            return null;
        }
        return getBrowserObject(ua, originalUrl);
    }
    if (userAgent && href) {
        return getBrowserObject(userAgent, href);
    }
    return null;
}
const browserInstance = /*#__PURE__*/ detectBrowser();

export { browserInstance as default, detectBrowser, getBrowserObject };
